import { HeaderBar } from '@fortem-monorepo/react-spa'

import { LayoutOutlet } from '@/components/LayoutOutlet'
import { NavigationTabs, NavigationTabsList } from '@/components/NavigationTabs'
import { PM_LINKS } from '@/constants/links'

export interface PMLayoutProps {}

export const PMLayout: React.FC<PMLayoutProps> = ({}) => {
  return (
    <>
      <HeaderBar>
        <NavigationTabs>
          <NavigationTabsList links={PM_LINKS} />
        </NavigationTabs>
      </HeaderBar>
      <LayoutOutlet />
    </>
  )
}
